import memoize from 'lodash/memoize';

import { fg } from '@atlaskit/platform-feature-flags';

import {
	getSAINHelloLayerFrontendExperiment,
	hasSAINLayerParamValue,
} from './get-sain-layer-frontend-experiment';

const isLuminaEnabledUnmemoized = () => {
	if (fg('kd_dynamic_layout_in_sain')) {
		return true;
	}

	// Do not file exposure. We use backend event to track exposure instead.
	const { serveExperiment } = getSAINHelloLayerFrontendExperiment({
		abTestId: 'kd_lumina_in_sain',
	});

	return serveExperiment;
};

const isSourcesInShortSAINAnswersEnabledUnmemoized = () => {
	if (fg('kd_sain_show_sources_in_short_answers')) {
		return true;
	}

	return hasSAINLayerParamValue('sourcesInShortSAINAnswers', 'test');
};

const isThirdPartyBannerEnabledUnmemoized = () => {
	if (fg('kd_sain_show_third_party_banner')) {
		return true;
	}

	return hasSAINLayerParamValue('SAINThirdPartyBanner', 'test');
};

export const SAINFeatureControl = {
	isLuminaEnabled: memoize(isLuminaEnabledUnmemoized),
	isSourcesInShortSAINAnswersEnabled: memoize(isSourcesInShortSAINAnswersEnabledUnmemoized),
	isThirdPartyBannerEnabled: memoize(isThirdPartyBannerEnabledUnmemoized),
};
